export default __webpack_public_path__ + "static/media/wb-6.6169cc01.webp";